
import jsPDF from "jspdf";
import { Conversation } from "@/types/conversation";
import { Message } from "@/types/message";
import { filterToLatestVersions } from "./messageProcessor";
import { 
  createPdfDocument, 
  addCaseInformation, 
  addRefundDetails, 
  addFooterNote, 
  generatePdfFilename
} from "./documentCreator";
import { addMessageTable } from "./messageTableCreator";

/**
 * Creates and exports a PDF document containing the refund conversation
 */
export const exportConversationToPdf = async (
  conversation: Conversation,
  messages: Message[],
  userFullName: string = "Customer",
  onProgress?: (progress: number) => void
): Promise<string> => {
  // Start progress
  onProgress?.(5);
  
  // Filter messages to only include the latest version from each thread
  const filteredMessages = filterToLatestVersions(messages);
  onProgress?.(15);
  
  // Create the document
  const doc = createPdfDocument();
  onProgress?.(25);
  
  // Add content sections with proper spacing
  const caseInfoEndY = addCaseInformation(doc, conversation, userFullName);
  onProgress?.(40);
  
  const refundDetailsEndY = addRefundDetails(doc, conversation, caseInfoEndY);
  onProgress?.(50);
  
  // Add message history table with proper positioning
  const finalY = addMessageTable(doc, filteredMessages, userFullName, conversation.merchant || "Merchant", refundDetailsEndY);
  onProgress?.(75);
  
  // Add footer note
  addFooterNote(doc, finalY);
  onProgress?.(85);
  
  // Generate filename and save PDF
  const filename = generatePdfFilename(conversation);
  doc.save(filename);
  onProgress?.(100);
  
  return filename;
};
